import { Drawer } from "antd";
import { color } from "theme/aiInventory";

export type DrawerShellProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: number | string;
};

/** Inner content owns its own close button — the default antd header is hidden. */
export const DrawerShell: React.FC<DrawerShellProps> = ({
  open,
  onClose,
  children,
  width = "78%",
}) => (
  <Drawer
    open={open}
    onClose={onClose}
    width={width}
    destroyOnClose
    closable={false}
    styles={{
      body: {
        paddingTop: 20,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      },
      header: { display: "none" },
      content: { borderTop: `3px solid ${color.controlPlane}` },
    }}
  >
    {children}
  </Drawer>
);
